'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * IT subtotal Row
 */
ngModule.directive('itSubtotalRow', function () {
  return {
    restrict: "A",
    // require: "^infiniTable" est problématique car la ligne est "linkée" avant d'être ajoutée au DOM,
    // le controller parent ne peut donc pas être trouvé.
    // A la place, on récupère le controller via le scope, car il est exposé avec `controllerAs: '$tableCtrl'`
    // sur la directive infiniTable.
    scope: true,
    link: function link($scope, $el, $attrs) {
      var tableCtrl = $scope.$tableCtrl;
      if (!tableCtrl) {
        console.error("itSubtotalRow: Le contrôleur infiniTable n'a pas été trouvé sur le scope.");
        return;
      }
      var context = tableCtrl.getContext();
      var config = tableCtrl.getConfig();
      var subtotalCellLinker = tableCtrl.linkers.subtotalCell;

      // permet de sauter autant de colonne que mise en colspan
      var nbcolspan = 0;
      _.each(context.visibleColumns, function (computed) {
        var column = computed.column;
        var cellScope = $scope.$new();
        cellScope.column = computed;
        if (nbcolspan === 0) {
          // add subtotal row cell
          subtotalCellLinker(cellScope, function (subtotalCell) {
            computed.subtotalCellInjector(cellScope, subtotalCell);
            if (column.subtotalCellClass != null) {
              subtotalCell.addClass(column.subtotalCellClass);
            } else if (column.cellClass) {
              subtotalCell.addClass(column.cellClass);
            }
            if (column.subtotalColspan) {
              subtotalCell.attr('colspan', column.subtotalColspan);
              nbcolspan = column.subtotalColspan - 1;
            }
            computed.subtotalCell = subtotalCell;
            subtotalCell.appendTo($el);
          });
        } else {
          nbcolspan--;
        }
      });

      // row selection. See itRowSelectionFeature.
      if (config.allowSubtotalRowSelection) {
        $el.addClass("it-selectable-row");
        $scope.$watch(function () {
          return tableCtrl.getRowSelection();
        }, function (selection) {
          if (selection === $scope.model ||
          // pour les tree
          selection && selection.$node && selection.model === $scope.model) {
            $el.addClass("it-selected");
          } else {
            $el.removeClass("it-selected");
          }
        });
      }
      var cell = '<td class="scrollbar">';
      $(cell).appendTo($el);
    },
    controller: function controller($scope) {}
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/infiniTable/standard/itSubtotalRow.js
// module id = 2816
// module chunks = 13